import { Model } from "@/models";
import ClientCompany from "@/models/Company";
import ClientAgency from "./Agency";
import ClientAgentCompanyAgentAssociation from "./AgentCompanyAgentAssociation";
import ClientAgentCompanyAssociation from "./AgentCompanyAssociation";
import ClientEntityWithHierarchyInterface from "./Interfaces/ClientEntityWithHierarchyInterface";

export default class ClientProductWithHierarchy
  extends Model
  implements ClientEntityWithHierarchyInterface
{
  static type = "clientsAgentProductWithHierarchies";

  name!: string;
  term!: string;
  agentCompanyId!: string;

  principalCompanyId!: string | number;
  principalProductId?: string | number;

  agentCompany?: ClientCompany;
  currentAgentCompanyAgentAssociations?: ClientAgentCompanyAgentAssociation[];
  currentAgency?: ClientAgency;
  currentAgentCompanyAssociation?: ClientAgentCompanyAssociation;
}
